import React, {useEffect, useState} from 'react';
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import Loader from "../Loader";
import Header from "../Header/Header";
import DateAndStore from "./DateAndStore";
import SellFactorKOL from "../SellFactor/FactorKOL/SellFactorKOL";
import SellFactorJOZ from "../SellFactor/FactorJOZ/SellFactorJOZ";
import AddProductSection from "../SellFactor/FactorJOZ/AddProductSection";
import TransferBetweenStoresTable from "./TransferBetweenStoresTable";
import {useLocation} from "react-router-dom";
import {TransferBetweenStoresData} from "./TransferBetweenStoresData";
import {prefixUrl} from "../../utils/utilsData";
import _axios from  "../../httpService"
import {toast} from "react-toastify";

const TransferBetweenStores = () => {

  const [sendData, setSendData] = ObjectDataHolder();
  const [initialData, setInitialData] = ObjectDataHolder();
  const [componentData, setComponentData] = ObjectDataHolder();
  const [loading, setLoading] = useState(true);
  const myLocation = useLocation();

  useEffect(() => {

    if (myLocation.state.id) {

      //debugger
      const id = myLocation.state.id
      if (!id) {
        toast(" مقدار آیدی تعیین نشده است.")
        return
      }
      _axios.get(prefixUrl() + "/storeRemittance/?request=remittanceSubmittedData&seriesId=" +id).then(res=>{
        const data = res.data;
        if(data.status){
          setSendData(data.data)
          setLoading(false)
        }else {
          toast.error(data.message)
        }
      })

    } else {

      setSendData(TransferBetweenStoresData.sendData)
      setLoading(false)

    }

  }, [])
  return (
    <>
      <div className={"factor-component"}
      >
        {loading ? <Loader/> :
          <>
            {/*<DateAndStore*/}
            {/*  sendData={sendData} setSendData={setSendData} initialData={initialData}*/}
            {/*  componentData={componentData} setComponentData={setComponentData}*/}
            {/*/>*/}
            <>
              <div className="total">

                <DateAndStore
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </div>
              <div className="total">
                <h5 className="factor-title">جزئیات حواله</h5>
                <AddProductSection
                  sendData={sendData} setSendData={setSendData} initialData={initialData}
                  componentData={componentData} setComponentData={setComponentData}
                  isShowStoreRoom={false}
                  mode={"remittance"}
                />
                <TransferBetweenStoresTable
                  sendData={sendData} setSendData={setSendData} initialData={initialData}
                  componentData={componentData} setComponentData={setComponentData}
                />
              </div>
            </>
          </>
        }


      </div>
    </>
  );
};

export default TransferBetweenStores;
